/**
 * Service API des signalements de réponses de l'IA (backoffice).
 *
 * Dépôt par l'app : POST /api/v1/ia/signalements. La console les lit dans la
 * file de modération unique et les marque traités ici (PATCH).
 */

import { ADMIN_URLS } from '../config/adminApi';
import { createApiClient, withEnv } from '../lib/http';
import { AppEnvironment } from '../config/environment';

const api = createApiClient();

class IaSignalementsApiService {
  /** Marque un signalement traité (ou le rouvre). */
  static async setTraite(env: AppEnvironment, id: string, traite: boolean): Promise<void> {
    await api.patch(`${ADMIN_URLS.iaSignalements}/${id}`, { traite }, withEnv(env));
  }
}

export default IaSignalementsApiService;
